const Action = require("components/abstract/Action");
const PropTypes = require("prop-types");
const assign = require("object-assign");
const Icon = require("components/addons/Icon");

class SelectBox extends Action {

	/////////////////////////////////
	// Init
	/////////////////////////////////

	static get propTypes() {
		return assign(super.propTypes, {
			checked: PropTypes.bool,

			id: PropTypes.any.isRequired,
			title: PropTypes.any.isRequired,
			subtitle: PropTypes.any,
			icon: PropTypes.string,
			type: PropTypes.string,

			image: PropTypes.shape({
				src: PropTypes.string.isRequired,
				alt: PropTypes.string.isRequired,
			}),
		});
	}

	/////////////////////////////////
	// Methods
	/////////////////////////////////

	_onAction = () => {
		return this.onAction(this.props.id);
	}

	/////////////////////////////////
	// Getters
	/////////////////////////////////

	get defaultClassNames() {
		return [
			'select-box',
			this.props.type,
			this.props.checked ? 'selected' : null
		];
	}

	/////////////////////////////////
	// Renders
	/////////////////////////////////

	renderImage() {

		if(this.props.icon){
			return <Icon name={this.props.icon} title={this.props.title} />
		}

		if (!this.props.image) return;

		return (<img src={this.props.image.src} alt={this.props.image.alt} />);
	}

	renderSubtitle() {
		if (!this.props.subtitle) return;

		if (typeof this.props.subtitle === 'function') {
			return this.props.subtitle();
		}

		return (<p>{this.props.subtitle}</p>);
	}
	
	render() {
		return(
			<div onClick={this._onAction} className={this.classNames}>
				{this.renderImage()}
				<div className="select-box-content">
					<div className="title">{this.props.title}</div>
					{this.renderSubtitle()}
				</div>
			</div>
		);
	}

}

module.exports = SelectBox;
